import { render, staticRenderFns } from "./Dish.vue?vue&type=template&id=4785df76&scoped=true"
import script from "./Dish.vue?vue&type=script&lang=ts"
export * from "./Dish.vue?vue&type=script&lang=ts"
import style0 from "./Dish.vue?vue&type=style&index=0&id=4785df76&prod&lang=scss&scoped=true"
import style1 from "./Dish.vue?vue&type=style&index=1&id=4785df76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785df76",
  null
  
)

export default component.exports